<script>
import api from '@/api'
import { alertSuccess } from '@/helpers/swal'

export default {
  data() {
    return {
      pagetitle: 'Devices',
      bulk: {
        file: null,
      },
      errors: {},
    }
  },
  methods: {
    onFileChange(e) {
      this.bulk.file = e.target.files[0]
    },
    async uploadBulkUpdate() {
      if (!this.validateRequest()) return

      const formData = new FormData()
      formData.append('file', this.bulk.file)

      try {
        const response = await api.post('/devices/update/bulk', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        alertSuccess(response.data)
        this.$router.push({ name: 'devices' })
      } catch (error) {
        alert(error.response?.data?.message || 'Failed to update devices')
      }
    },
    validateRequest() {
      this.errors = {}
      if (!this.bulk.file) this.errors.file = 'CSV file is required'
      return Object.keys(this.errors).length === 0
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-xl-6">
      <Teleport to="#elePageTitle">
        {{ pagetitle }}
      </Teleport>
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Bulk Update Devices</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="uploadBulkUpdate">
            <div class="mb-3">
              <label class="form-label">CSV File</label>
              <input type="file" class="form-control" accept=".csv" @change="onFileChange" />
              <div class="form-text">
                Match devices with <code>Host</code> or <code>Sensor Name</code>
              </div>
              <div v-if="errors.file" class="invalid-feedback d-block">{{ errors.file }}</div>
            </div>
            <button type="submit" class="btn btn-success">Update</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
